import { styled } from "@mui/material/styles";

export const Container = styled("div")(({ theme }) => ({
  width: "100%",
  "& .progress-container": {
    background: "#02002B",
    border: "#211F45 1px solid",
    borderRadius: "12px",
    padding: "16px",
    marginTop: "20px",
    "& .progress-item": {
      display: "flex",
      justifyContent: "space-between",
      "& .file-actions": {
        display: "flex",
        gap: "10px"
      }
    }
  }
}));
